import React, { createContext, useContext, useState } from "react"

interface PlaceDetailsContextType {
  isOpen: boolean
  place: any
  dayDate: string | null
  setIsOpen: (open: boolean) => void
  openPanel: (place: any, dayDate?: string) => void
  closePanel: () => void
}

const PlaceDetailsContext = createContext<PlaceDetailsContextType | undefined>(
  undefined
)

export function PlaceDetailsProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [place, setPlace] = useState<any>(null)
  const [dayDate, setDayDate] = useState<string | null>(null)

  const openPanel = (placeData: any, dayDate?: string) => {
    setPlace(placeData)
    setDayDate(dayDate || null)
    setIsOpen(true)
  }

  const closePanel = () => {
    setIsOpen(false)
    setPlace(null)
    setDayDate(null)
  }

  return (
    <PlaceDetailsContext.Provider
      value={{ isOpen, place, dayDate, setIsOpen, openPanel, closePanel }}
    >
      {children}
    </PlaceDetailsContext.Provider>
  )
}

export function usePlaceDetails() {
  const context = useContext(PlaceDetailsContext)
  if (!context) {
    throw new Error(`usePlaceDetails must be used within PlaceDetailsProvider`)
  }
  return context
}
